import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/services/api.base.service';
import { environment } from '@env/environment.local';
import { queryParamsSubBrand } from '../financial-setup/model.models';
import { FileType } from '@app/models/fileTypes.enum';


@Injectable({
    providedIn: 'root',
})
export class SubBrandService {
    constructor(public api: ApiService, public httpClient: HttpClient) { }

    //#region QUOTE-SERVICE SUB-BRAND
  getAllSubBrands(data: queryParamsSubBrand): Observable<any> {
      //filtros
      return this.api.post(
        `${environment.API_QUOTE_SERVICE}/sub-brands/all`,data);
  }

  getSubBrand(id: number, data: any): Observable<any> {
      return this.api.post(
        `${environment.API_QUOTE_SERVICE}/sub-brands/${id}`, data);
  }

  createSubBrand(data: any): Observable<any> {
    return this.api.post(
        `${environment.API_QUOTE_SERVICE}/sub-brands`, data);
  }

  updateSubBrand(id: number, data: any): Observable<any> {
        return this.api.put(
          `${environment.API_QUOTE_SERVICE}/sub-brands/${id}`, data);
    }

  deleteSubBrand(id: number): Observable<any> {
      return this.api.deleteWithoutBody(
        `${environment.API_QUOTE_SERVICE}/sub-brands/${id}`
      );
    }

  hardDeleteSubBrand(id: number): Observable<any> {
      return this.api.deleteWithoutBody(
        `${environment.API_QUOTE_SERVICE}/sub-brands/hard-delete/${id}`
      );
    }

    //#region FILE-SERVICE
  getAttachmentById(id: number) {
    return this.api.get(
      `${environment.API_FILE_SERVICE}/file/${id}`);
  }

  getAllAttachment() {
    //obtener todos los archivos
    return this.api.get(
      `${environment.API_FILE_SERVICE}/file`);
  }

  createAttachment(data: any) {
    //crear adjunto mandar por form data
    return this.api.post(
      `${environment.API_FILE_SERVICE}/file`, data);
  }

  getAttachmentByElementId(id: number, type: FileType, includePublicUrl = true) {
    let params = new HttpParams().set('typeFile', type);
    if (includePublicUrl) {
      params = params.set('includePublicUrl', 'true');
    }
    return this.api.getWithOptions(`${environment.API_FILE_SERVICE}/file/elements/${id}`, { params });
  }

  deleteAttachmentById(id: number) {
    return this.api.delete(
      `${environment.API_FILE_SERVICE}/file/${id}`, '');
  }

}
